import { render, staticRenderFns } from "./InstallmentFeeInput.vue?vue&type=template&id=1fb2b410&scoped=true&"
import script from "./InstallmentFeeInput.vue?vue&type=script&lang=js&"
export * from "./InstallmentFeeInput.vue?vue&type=script&lang=js&"
import style0 from "./InstallmentFeeInput.vue?vue&type=style&index=0&id=1fb2b410&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb2b410",
  null
  
)

export default component.exports